import React from "react";

const Common = () => {
  return (
    <div style={{ textAlign: "center", marginTop: 120 }}>
      <h1>Choice Your Option</h1>
      <hr className="w-50 mx-auto" />
    </div>
  );
};

export default Common;
